// Mirrors BookingErrorCode in svc-experiences (src/utils/exception-utils/booking-error-codes.ts).
// svc-experiences emits these opaque codes in API error bodies for localisation readiness;
// the admin UI translates them back to human-readable strings at the service boundary.
export const bookingErrorCodeMessages: Record<string, string> = {
  // Offer-level
  OFFER_NOT_FOUND: 'Offer not found or no longer available',
  OFFER_OUTSIDE_SALES_DATES: 'Offer is outside its sales dates',
  OFFER_BOOKING_DEADLINE_PASSED: 'Booking deadline has passed for this offer',
  OFFER_EXTRA_ITEMS_ONLY_NOT_ALLOWED: 'Cannot book extra items only for this offer',
  OFFER_BNBL_AND_TRANSFER_CONFLICT: 'Cannot allow BNBL and transfer at the same time',

  // Item-level
  ITEM_MISSING_PROVIDER_ID: 'Item is missing provider ID',
  ITEM_CANCELLED: 'This item is cancelled',
  ITEM_ALREADY_HAS_BOOKING: 'This item already has a booking',
  ITEM_FROM_DIFFERENT_ORDER: 'Item belongs to a different order',
  ITEM_MISSING_PROVIDER_ORDER_ID: 'Item is missing provider order ID',
  ITEM_INVALID_COMPLEMENTARY: 'Invalid complementary item',

  // Provider/brand
  INVALID_PROVIDER: 'Wrong ID or provider not valid',
  BRAND_NOT_AVAILABLE: 'Brand not available for this offer',
};

export function mapBookingErrorCode(message: unknown): string | undefined {
  if (typeof message !== 'string') {
    return undefined;
  }
  return bookingErrorCodeMessages[message];
}
